module.exports = __webpack_public_path__ + "static/img/ic_video_unlock_land.c56b7fdb.png";